/* eslint-disable no-console, no-restricted-globals */
import getWidenGalleryFilterData from './widen-gallery-filters';

let mediaLoadOffset = 0;
let mediaLoadCallback;
let onMediaLoadComplete;
let mediaLoadLimit = 25; // Only load 25 initially to build out gallery, then switch to max allowed (100)

const setMediaLoadCallback = (callback) => {
  mediaLoadCallback = callback;
};

const setMediaLoadCompleteCallback = (callback) => {
  onMediaLoadComplete = callback;
};

const getDimensionsFromAssetUrl = (url) => {
  // Returns object w/ width/height or null... should be at position 6 in array
  const a = url.split('/');
  const dims = a[6];
  if (dims !== undefined) {
    if (dims.indexOf('px') !== -1 && !isNaN(parseInt(dims, 10))) {
      const b = dims.split('x');
      // Assume square, only one dimension
      if (b[1] === '') {
        b[0] = dims;
        b[1] = dims;
      }
      return {
        width: parseInt(b[0], 10),
        height: parseInt(b[1], 10),
      };
    }
  }
  return null;
};

const updateAssetUrlDimensions = (asset) => {
  const urlDims = getDimensionsFromAssetUrl(asset.src);
  if (urlDims !== null) {
    // Check for square image
    if (asset.src.indexOf(`${urlDims.width}x`) === -1) {
      return asset.src
        .replace(`${urlDims.height}px`, `${asset.width}x${asset.height}px`);
    }
    return asset.src
      .replace(`${urlDims.width}x`, `${asset.width}x`)
      .replace(`${urlDims.height}px`, `${asset.height}px`);
  }
  return asset.src;
};

const getIdFromAssetUrl = (url) => {
  const fragment = url.match(/springswindowfashions\/(.*?)\//);
  if (fragment !== null) {
    return fragment[1];
  }
  return url;
};

const getFileNameFromVideoEmbedUrl = (url) => {
  const fragment = url.match(/([^/]+$)/);
  if (fragment !== null) {
    return fragment[1];
  }
  return url;
};

const flattenMetaDataArray = arr => (
  arr.join(', ')
);

const getFirstMetaDataArrayValue = (arr) => {
  if (arr.length === 0) {
    return '';
  }
  return arr[0];
};

const getAssetDescription = (arr) => {
  const desc = getFirstMetaDataArrayValue(arr);
  if (desc !== '') {
    return desc;
  }
  return 'A room scene featuring products by Bali.';
};

const getFilename = (filename) => {
  const name = filename;
  if (name.indexOf('.') !== -1) {
    return name.substr(0, name.lastIndexOf('.'));
  }
  return name;
};

const getUrlForWidth = (filename, id, width) => {
  const name = getFilename(filename);
  return `https://embed.widencdn.net/img/springswindowfashions/${id}/${width}px/${name}.webp`;
};

const getVideoPosterUrl = (filename, id) => {
  const name = getFilename(filename);
  return `https://embed.widencdn.net/poster/640/springswindowfashions/${id}/${name}`;
};

const getProductLineId = (product) => {
  const { productEpiReferences } = window;
  if (productEpiReferences !== undefined) {
    const data = productEpiReferences.find(item => item.product === product);
    if (data !== undefined) {
      return data.productLineId;
    }
  }
  return '';
};

const getProductUrl = (product) => {
  const { productEpiReferences } = window;
  if (productEpiReferences !== undefined) {
    const data = productEpiReferences.find(item => item.product === product);
    if (data !== undefined) {
      return data.productUrl;
    }
  }
  return '';
};

const parseImageData = (data) => {
  // console.log(data.items);
  data.items.forEach((item) => {
    // console.log(`${item.external_id} /  ${flattenMetaDataArray(item.metadata.fields.Product)}`);
    if (item.file_properties.format_type === 'image') {
      window.MediaGalleryData.mediaItems.push({
        imageUrl: getUrlForWidth(item.filename, item.external_id, 1024),
        imageAlt: '',
        filename: getFilename(item.filename),
        title: item.id,
        product: getFirstMetaDataArrayValue(item.metadata.fields.Product),
        productLineId: getProductLineId(getFirstMetaDataArrayValue(item.metadata.fields.Product)),
        productLineUrl: getProductUrl(getFirstMetaDataArrayValue(item.metadata.fields.Product)),
        id: item.external_id,
        type: 'Image',
        description: getAssetDescription(item.metadata.fields.webReadyCaption),
        productLineName: flattenMetaDataArray(item.metadata.fields.Product),
        colorRange: flattenMetaDataArray(item.metadata.fields.colorRange),
        designStyle: flattenMetaDataArray(item.metadata.fields.RoomStyle),
        roomType: flattenMetaDataArray(item.metadata.fields.RoomType),
        columnSize: 'col-xs-12 col-sm-4',
        active: false,
      });
    } else if (item.file_properties.format_type === 'video') {
      const videoFileName = item.filename.replace(/\s/gi, '%20');
      const posterImage = `https://embed.widencdn.net/poster/640/springswindowfashions/${item.external_id}/${videoFileName}`;
      window.MediaGalleryData.mediaItems.push({
        videoUrl: `https://embed.widencdn.net/video/springswindowfashions/${item.external_id}/${videoFileName}`,
        posterImage,
        id: item.external_id,
        type: 'Video',
        title: getFirstMetaDataArrayValue(item.metadata.fields.videoTitle),
        description: getFirstMetaDataArrayValue(item.metadata.fields.description),
        productLineName: '',
        colorRange: '',
        designStyle: '',
        roomType: '',
        columnSize: 'col-xs-12 col-sm-4',
        active: false,
      });
    }
  });
  // console.log(window.MediaGalleryData.mediaItems);
};

const getMediaItemData = (onInitLoadComplete) => {
  const { requestUrl, galleryWidenQueryParams } = window;
  const request = new XMLHttpRequest();
  let url = requestUrl;
  let requestMethod = 'POST';
  if (window.requestMethod) {
    requestMethod = window.requestMethod; /* eslint-disable-line prefer-destructuring */
  }
  const urlDataParam = `?query=${galleryWidenQueryParams}&limit=${mediaLoadLimit}&offset=${mediaLoadOffset}&expand=file_properties,metadata`;
  url = `${requestUrl}?data=${encodeURIComponent(urlDataParam)}`;
  if (window.additionalHeader) {
    url = `${requestUrl}${galleryWidenQueryParams}&limit=${mediaLoadLimit}&offset=${mediaLoadOffset}&expand=file_properties,metadata`;
  }
  request.open(requestMethod, url, true);
  request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  if (window.additionalHeader) {
    request.setRequestHeader(window.additionalHeader.name, window.additionalHeader.value);
  }
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const data = JSON.parse(request.responseText);
      const totalCt = parseInt(data.total_count, 10);
      const itemsLoaded = window.MediaGalleryData.mediaItems.length;
      if (mediaLoadOffset <= parseInt(data.total_count, 10)) {
        mediaLoadOffset += mediaLoadLimit;
        mediaLoadLimit = 100;
        parseImageData(data);
        getMediaItemData();
      }
      // Run first time only
      if (onInitLoadComplete !== undefined) {
        onInitLoadComplete();
      }
      // Run everytime
      if (mediaLoadCallback !== undefined) {
        mediaLoadCallback();
      }
      // Run last time/on complete
      if (itemsLoaded === totalCt && onMediaLoadComplete !== undefined) {
        window.MediaGalleryData.filters = getWidenGalleryFilterData(window.MediaGalleryData.mediaItems);
        onMediaLoadComplete();
      }
    }
  };
  request.onerror = () => {
    console.log(request);
  };
  request.send();
};

const init = (callback) => {
  window.MediaGalleryData.filters = getWidenGalleryFilterData(window.MediaGalleryData.mediaItems);
  getMediaItemData(callback);
};

export {
  getDimensionsFromAssetUrl,
  getIdFromAssetUrl,
  getMediaItemData,
  getProductUrl,
  init,
  setMediaLoadCallback,
  setMediaLoadCompleteCallback,
  updateAssetUrlDimensions,
  getVideoPosterUrl,
  getFileNameFromVideoEmbedUrl,
};
/* eslint-enable no-console, no-restricted-globals */
